import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./home.scss";
import Header from "../_Common/header";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Modal,
  Row,
} from "react-bootstrap";

import sailingIcon from "../../assets/img/home/our-fleet/icons/sailing-boat.png";
import boatIcon from "../../assets/img/home/our-fleet/icons/boat.png";
import starIcon from "../../assets/img/home/our-fleet/icons/star.png";
import lightingIcon from "../../assets/img/home/our-fleet/icons/lighting.png";

import sailBoatsImg from "../../assets/img/home/our-fleet/sail-boats.png";
import sailYachtsImg from "../../assets/img/home/our-fleet/sail-yachts.png";
import motorYachtsImg from "../../assets/img/home/our-fleet/motor-yachts.png";
import speedBoatsImg from "../../assets/img/home/our-fleet/speed-boats.png";
import mainSectionBg from "../../assets/img/home/main-section-bg.png";

import luxurySailingExperienceImg from "../../assets/img/home/featured-experiences/luxury-sailing-experience.png";
import elegantMotorYachtImg from "../../assets/img/home/featured-experiences/elegant-motor-yacht.png";
import exclusiveYachtPartyImg from "../../assets/img/home/featured-experiences/exclusive-yacht-party.png";
import sunsetCruiseYachtImg from "../../assets/img/home/featured-experiences/sunset-cruise-yacht.png";
import privateLuxuryYachtImg from "../../assets/img/home/featured-experiences/private-luxury-yacht.webp";

import SunsetCruiseIcon from "../../assets/img/home/featured-experiences/icons/sunset.png";
import speedBoatIcon from "../../assets/img/home/featured-experiences/icons/boat.png";
import privatePartyIcon from "../../assets/img/home/featured-experiences/icons/confetti.png";
import corporateMeetingsIcon from "../../assets/img/home/featured-experiences/icons/discussion.png";
import eventCelebrationsIcon from "../../assets/img/home/featured-experiences/icons/celebration.png";
//import anniversaryIcon from "../../assets/img/home/featured-experiences/icons/party-popper.png";


export default function Home() {
  // YATCH DATA
  const yachtData = [
    {
      title_icon: sailingIcon,
      title: "Sail Boats",
      capacity: "Traditional Elegance",
      description:
        "Experience the timeless charm of traditional sailing. Perfect for intimate gatherings and peaceful cruising along Mumbai's coastline.",
      tags: "6-8 Guests",
      image: sailBoatsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: boatIcon,
      title: "Sail Yachts",
      capacity: "Sophisticated Luxury",
      description:
        "Elevate your celebration with our spacious luxury sail yachts. Combining traditional sailing with modern amenities for an unforgettable...",
      tags: "15-35 Guests",
      image: sailYachtsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: starIcon,
      title: "Motor Yachts",
      capacity: "Ultimate Prestige",
      description:
        "Experience the pinnacle of luxury with our modern motor yachts. State-of-the-art amenities, climate control, and opulent interiors.",
      tags: "15-25 Guests",
      image: motorYachtsImg,
      icon: "ri-group-line",
    },
    {
      title_icon: lightingIcon,
      title: "Speed Boats",
      capacity: "Thrilling Adventure",
      description: "Feel the adrenaline rush with our high-performance speed boats. Perfect for adventure seekers and quick coastal tours.",
      tags: "6-12 Guests",
      image: speedBoatsImg,
      icon: "ri-group-line",
    },
  ];

  const featuredExperiences = [
    {
      id: "luxury_sailing_experience",
      title_icon: SunsetCruiseIcon,
      title: "Sailing Experience",
      img: mainSectionBg,
      des: "Set sail on a premium yacht and enjoy an unforgettable experience with top-class amenities, perfect for relaxation or a scenic tour of the sea.",
    },
    {
      id: "elegant_motor_yacht",
      title_icon: speedBoatIcon,
      title: "Elegant Motor Yacht",
      img: elegantMotorYachtImg,
      des: "Cruise in style with our luxurious motor yacht. Featuring elegant design, comfortable seating, and advanced navigation systems for an extraordinary journey.",
    },
    {
      id: "exclusive_yacht_party",
      title_icon: privatePartyIcon,
      title: "Exclusive Yacht Party",
      img: exclusiveYachtPartyImg,
      des: "Host a lavish event aboard our beautifully decorated yacht. Perfect for weddings, parties, or any special occasion, complete with premium service and ambiance.",
    },
    {
      id: "sunset_cruise_yacht",
      title_icon: corporateMeetingsIcon,
      title: "Sunset Cruise Yacht",
      img: sunsetCruiseYachtImg,
      des: "Enjoy a stunning sunset over the Arabian Sea aboard a luxury yacht, accompanied by refreshing beverages and soft music for the perfect evening.",
    },
    {
      id: "private_luxury_yacht",
      title_icon: eventCelebrationsIcon,
      title: "Private Luxury Yacht",
      img: privateLuxuryYachtImg,
      des: "Escape to a world of luxury with a private yacht experience. Tailored to your preferences, ideal for personal getaways or intimate celebrations.",
    }
  ];

  // HANDLE FEATURE
  const [show, setShow] = useState(false);
  const [eventCelebrationsData, setEventCelebrationsData] = useState(null);
  const [currentFeaturedIndex, setCurrentFeaturedIndex] = useState(0);
  const [slideDirection, setSlideDirection] = useState("fade"); // 'fade', 'left', 'right'

  const handleNextSlide = () => {
    setSlideDirection("right");
    setCurrentFeaturedIndex((prev) => (prev === featuredExperiences.length - 1 ? 0 : prev + 1));
  };

  const handlePrevSlide = () => {
    setSlideDirection("left");
    setCurrentFeaturedIndex((prev) => (prev === 0 ? featuredExperiences.length - 1 : prev - 1));
  };

  const handleFeature = (data) => {
    setEventCelebrationsData(data);
    setShow(true);
  };

  // CLOSE MODAL
  const handleClose = () => {
    setShow(false);
    setEventCelebrationsData(null);
  };

  const whatsappLinks = {
    sunset_cruise:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Sunset Cruise.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    speed_boat_adventure:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Speed Boat Adventure.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    private_party_yacht:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Private Party Yacht.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    corporate_meetings:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Corporate Meetings & Events.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    event_celebrations:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Event Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

    anniversary_celebrations:
      "https://api.whatsapp.com/send/?phone=917666689265&text=Hi! I'd like to enquire about Anniversary Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",
  };

  const handleBookNow = (book) => {
    const link = whatsappLinks[book.id];

    if (link) {
      window.open(link, "_blank"); // NEW TAB ✔
    } else {
      console.error("No WhatsApp link found for ID:", book.id);
    }
  };

  // Touch/Swipe Logic
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      // Next Slide
      handleNextSlide();
    } else if (isRightSwipe) {
      // Prev Slide
      handlePrevSlide();
    }
  };

  return (
    <React.Fragment>
      <Header />

      {/* HOME SECTION  */}
      <section className="home-section" id="home">
        <Container className="sm-container">
          <div className="home-section-content">
            <h1 data-aos="fade-up" data-aos-duration="2500">
              Luxury Yacht & Sailing Experiences - Mumbai
            </h1>
            <p data-aos="fade-up" data-aos-duration="2700">
              Experience luxurious private sailing with <span className="brand-highlight">Book Sailing Mumbai</span> — perfect for
              celebrations, sunsets, and unforgettable moments.
            </p>
          </div>
        </Container>

        <div className="scroll-mouse">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </section>

      {/* FEATURED EXPERIENCE SECTION */}
      <section className="featured-experience-section" id="experiences">
        <Container>
          <div
            className="section-title text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h2>Featured Experiences</h2>
            <p>
              Choose from our curated selection of premium yacht and speed boat
              experiences
            </p>
          </div>

          <div className="featured-experience-slider-wrapper" data-aos="fade-up" data-aos-duration="2000">
            <div className="single-featured-card">
              <div
                className="featured-image-wrapper"
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
              >
                <div
                  className={`featured-bg-image ${slideDirection}`}
                  key={currentFeaturedIndex} // Force re-render for animation
                  style={{ backgroundImage: `url('${featuredExperiences[currentFeaturedIndex].img}')` }}
                ></div>

                {/* Pagination Controls - Kept on Image for intuitive control */}
                <button
                  className="slider-control left"
                  onClick={handlePrevSlide}
                >
                  <i className="ri-arrow-left-s-line"></i>
                </button>
                <button
                  className="slider-control right"
                  onClick={handleNextSlide}
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>

              <div className="featured-content-wrapper key={currentFeaturedIndex}">
                <div key={currentFeaturedIndex} className={`animate-text ${slideDirection}`}>
                  <h3>{featuredExperiences[currentFeaturedIndex].title}</h3>
                  <p>{featuredExperiences[currentFeaturedIndex].des}</p>
                </div>

                <Button
                  variant="primary"
                  className="btn-effect mt-3"
                  onClick={() => {
                    const message = `Hi! I'd like to enquire about ${featuredExperiences[currentFeaturedIndex].title}`;
                    const url = `https://wa.me/917666689265?text=${encodeURIComponent(message)}`;
                    window.open(url, "_blank");
                  }}
                >
                  Book Now via WhatsApp
                </Button>
              </div>
            </div>

            {/* Dots Indicator */}
            <div className="slider-dots">
              {featuredExperiences.map((_, idx) => (
                <span
                  key={idx}
                  className={`dot ${currentFeaturedIndex === idx ? 'active' : ''}`}
                  onClick={() => {
                    setSlideDirection(idx > currentFeaturedIndex ? "right" : "left");
                    setCurrentFeaturedIndex(idx);
                  }}
                ></span>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* OUR FLEET SECTION  */}
      <section className="our-fleet-section" id="our_fleet">
        <Container className="sm-container">
          <div
            className="section-title text-center"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="1000"
          >
            <h2>Our Fleet</h2>
            <p>
              Choose from our diverse collection of vessels, each designed for
              unique experiences on Mumbai's beautiful waters
            </p>
          </div>
        </Container>
        <div className="our-fleet-wrapper">
          {yachtData.map((item, i) => (
            <Link
              to="/full-fleet"
              key={i}
              className="our-fleet-card"
              style={{ backgroundImage: `url(${item.image})` }}
              data-aos="fade"
              data-aos-duration="2000"
            >
              <div className="yacht-card">
                <div className="desc">
                  <i className="ri-double-quotes-r"></i>

                  <p>{item.description}</p>
                </div>
                <div className="content">
                  <div className="yacht-title-icon">
                    <Image src={item.title_icon} alt="icon" />
                  </div>
                  <div>
                    <h4>{item.title}</h4>
                    <div className="tags">
                      <p className="capacity">{item.capacity}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <Container className="sm-container">
          <div
            className="expert-box"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <h5 className="title">Ready to Set Sail?</h5>
            <p className="subtitle">
              Choose your perfect vessel and create unforgettable memories on
              Mumbai's stunning waters. Expert crew, luxury amenities, and
              exceptional service await.
            </p>
            <div className="btn-group-custom">
              <Link className="btn-color btn-effect primary-btn text-white" to="/full-fleet">
                View Full Fleet Gallery
              </Link>
            </div>
          </div>
        </Container>
      </section>


      {/* GET IN TOUCH SECTION */}
      <section className="get-in-touch" id="contact">
        <Container>
          <div
            className="section-title text-center"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="1000"
          >
            <h2>Contact Us</h2>
            <p>Ready to embark on an unforgettable journey? Contact us to book your luxury yacht experience</p>
          </div>

          <div className="contact-row-wrapper">
            <div className="info-item">
              <div className="info-icon">
                <i className="ri-map-pin-line"></i>
              </div>
              <div className="info-text">
                <strong>Location</strong>
                <p>Gateway of India, Apollo Bandar, Colaba, Mumbai, Maharashtra 400001</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <i className="ri-phone-line"></i>
              </div>
              <div className="info-text">
                <strong>Phone</strong>
                <p>+91 76666 89265</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <i className="ri-time-line"></i>
              </div>
              <div className="info-text">
                <strong>Operating Hours</strong>
                <p>Mon - Sun: 7:00 AM - 10:00 PM</p>
              </div>
            </div>
          </div>

          <div className="contact-divider"></div>

          <div className="response-message text-center mt-4 mb-4 ">
            <p className="text-white">We respond to all inquiries at the soonest. For urgent bookings, please call us directly.</p>
          </div>
        </Container>
      </section>



      {/* EVENT CELEBRATIONS MODAL */}
      < Modal
        className="event-celebrations-modal"
        show={show}
        onHide={handleClose}
        animation={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            <Image src={eventCelebrationsData?.title_icon} alt="icon" />
            <span>{eventCelebrationsData?.title || "Event Celebrations"}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="event-celebrations-content">
            <div className="event-celebrations-img">
              {eventCelebrationsData?.img && (
                <Image src={eventCelebrationsData.img} fluid />
              )}
            </div>
            <h4>{eventCelebrationsData?.des}</h4>
          </div>

          <Button
            variant="primary"
            className="btn-effect w-100"
            onClick={() => handleBookNow(eventCelebrationsData)}
          >
            Book Now via WhatsApp
          </Button>
        </Modal.Body>
      </Modal >
    </React.Fragment >
  );
}
